import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { RegistrationsList } from 'src/app/administration/registrations-list';
import { RegistrationService } from 'src/app/administration/registrations/registration.service';

export interface EditTeamModalData {
  members: RegistrationsList[];
  outingIterationId: string;
  lastEditedBy: string;
}

@Component({
  selector: 'app-edit-team-modal',
  templateUrl: './edit-team-modal.component.html',
  styleUrls: ['./edit-team-modal.component.scss'],
  standalone: false
})
export class EditTeamModalComponent {
  form: FormGroup;
  saving = false;
  errorMessage: string | null = null;

  constructor(
    private fb: FormBuilder,
    private registrationService: RegistrationService,
    private dialogRef: MatDialogRef<EditTeamModalComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: EditTeamModalData
  ) {
    this.form = this.fb.group({
      teamCaptain: ['', Validators.required],
      startingHole: ['']
    });
    const first = data.members[0];
    this.form.patchValue({
      teamCaptain: (first?.teamCaptain || '').trim(),
      startingHole: (first?.startingHole || '').trim()
    });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  save(): void {
    this.errorMessage = null;
    if (this.form.invalid || this.data.members.length === 0) {
      this.form.markAllAsTouched();
      return;
    }
    const teamCaptain = String(this.form.get('teamCaptain')?.value ?? '').trim();
    const startingHole = String(this.form.get('startingHole')?.value ?? '').trim();
    this.saving = true;
    const { outingIterationId, lastEditedBy } = this.data;
    const requests = this.data.members.map((m) => {
      const body = {
        ...m,
        teamCaptain,
        startingHole,
        outingIterationId,
        lastEditedBy
      };
      return this.registrationService.update(m.id, body);
    });
    forkJoin(requests)
      .pipe(
        finalize(() => {
          this.saving = false;
        })
      )
      .subscribe({
        next: () => this.dialogRef.close(true),
        error: () => {
          this.errorMessage = 'Unable to save team changes. Please try again.';
        }
      });
  }
}
